"use strict";
const lodash_1 = require('lodash');
const actionTypes = require('../actionTypes');
function tasks(tasksState = buildTasksState(), action) {
    switch (action.type) {
        case actionTypes.LISTEN_TO_TASKS: {
            const listenToTasksAction = action;
            return Object.assign({}, tasksState, {
                tasksRef: listenToTasksAction.ref,
            });
        }
        case actionTypes.STOP_LISTENING_TO_TASKS: {
            return Object.assign({}, tasksState, {
                tasksRef: null,
            });
        }
        case actionTypes.LOGOUT: {
            return buildTasksState();
        }
        case actionTypes.TASK_ADDED: {
            const task = action.task;
            return Object.assign({}, tasksState, {
                tasks: Object.assign({}, tasksState.tasks, {
                    [task.id]: task,
                }),
            });
        }
        case actionTypes.TASK_CHANGED: {
            const task = action.task;
            return Object.assign({}, tasksState, {
                tasks: Object.assign({}, tasksState.tasks, {
                    [task.id]: task,
                }),
            });
        }
        case actionTypes.TASK_REMOVED: {
            const taskId = action.taskId;
            return Object.assign({}, tasksState, {
                tasks: lodash_1.omit(tasksState.tasks, taskId),
            });
        }
        default:
            return tasksState;
    }
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = tasks;
exports.getTasks = (state) => {
    if (!state.tasks) {
        return [];
    }
    return Object.keys(state.tasks).map(id => state.tasks[id]);
};
const buildTasksState = (partialState = {}) => Object.assign({
    tasks: null,
    tasksRef: null,
    tasksListener: null
}, partialState);



/** WEBPACK FOOTER **
 ** ./src/reducers/tasks.ts
 **/